<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 ziro-report-content">
    @if (isReadOnly !== null) {
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div
            [innerHTML]="
              (isReadOnly
                ? 'tkey;menu.report.unused_phone_button_template.description.read_only'
                : 'tkey;menu.report.unused_phone_button_template.description'
              ) | escapeHtml
            "
          ></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
    }

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading && unusedPbts.length > 0) {
      <ziro-datatable
        [isCondensed]="true"
        [columns]="columns"
        [rowDataSource]="unusedPbts"
        [uniqueRowIdentifier]="null"
        [showSelectColumn]="!isReadOnly"
        [mainFilterPlaceholder]="
          ('tkey;menu.report.unused_phone_button_template.datatable.search.placeholder' | translate) + '...'
        "
        [stickyColumnCount]="1"
        (rowSelected)="setDeleteButtonState()"
        [dataAutomation]="tableDataAutomation"
        [class]="'ziro-card'"
      >
        <ziro-datatable-switch-filter
          [label]="'tkey;menu.report.unused_phone_button_template.toggle.label' | translate"
          [matchFn]="showAllFilter"
          [dataAutomation]="'show-all-switch-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-switch-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;menu.report.unused_phone_button_template.protocol.label'"
          [items]="protocolFilterOptions"
          [matchFn]="isProtocolMatch"
          [dataAutomation]="'unused-pbt-protocol-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;menu.report.unused_phone_button_template.cucm_server.label'"
          [items]="cucmServerFilterOptions"
          [matchFn]="isCucmServerMatch"
          [dataAutomation]="'unused-pbt-cucm-server-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;menu.report.unused_phone_button_template.type.label'"
          [items]="typeFilterOptions"
          [matchFn]="isTypeMatch"
          [dataAutomation]="'unused-pbt-type-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    }
  </div>
</div>

@if (!isReadOnly) {
  <ziro-bottom-nav></ziro-bottom-nav>
}
